import React from 'react';
import { Box } from "@mui/material";
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import eyeIcon from "../../../src/assets/images/eye.svg"
import { DataGrid } from '@mui/x-data-grid';
import VisibilityIcon from '@mui/icons-material/Visibility';

const columns = [
    { field: 'id', headerName: 'S.No', width: 200 },
    {
        field: 'patientName',
        headerName: 'Patient Name',
        width: 250,
        // editable: true,
    },
    {
        field: 'quizScore',
        headerName: 'Quiz Score',
        width: 230,
        // editable: true,
    },

    {
        field: 'location',
        headerName: 'location',
        // editable: true,
        width: 230,
    },
    {
        field: 'date',
        headerName: 'Posted Date',
        width: 230,
        // editable: true,
    },
    {
        field: 'status',
        headerName: 'Status',
        width: 300,
        cellclassName: 'blueText',
        // render: rowData => <div dangerouslySetInnerHTML={{ __html: rowData.description }} />
        renderCell: (params) => ( // Render cell with eye icon
            <p>Completed</p>
        )


    },



    {
        field: 'Action',
        headerName: 'Action',
        renderCell: (params) => ( // Render cell with eye icon
            <img src={eyeIcon} alt="View" style={{ color: 'red' }} />
        ),
        renderCell: (params) => ( // Render cell with visibility icon
            <IconButton style={{ color: 'red' }}>
                <VisibilityIcon style={{ color: '#1777BE ' }} />
            </IconButton>
        ),
        width: 100,
    },


];

const rows = [
    { id: 1, quizScore: 15, patientName: 'John Dawn', location: 'Texas', date: '04.10.2024' },


    { id: 2, quizScore: 14, patientName: 'Garden Grove', location: 'Alaska', date: '04.11.2024', },
    { id: 3, quizScore: 12, patientName: 'Golden Oak ', location: 'Arizona', date: '04.12.2024', },
    { id: 4, quizScore: 15, patientName: 'Pine valley', location: 'Arkansas', date: '04.13.2024', },
    { id: 5, quizScore: 14, patientName: 'Phoenix Center', location: 'California', date: '04.14.2024', },
    { id: 6, quizScore: 12, patientName: 'Olympus Billy', location: 'California', date: '04.15.2024', },
    { id: 7, quizScore: 14, patientName: ' Garden Grove ', location: 'California', date: '04.16.2024', },
    { id: 8, quizScore: 14, patientName: ' Garden Grove ', location: 'California', date: '04.16.2024', },
    { id: 9, quizScore: 14, patientName: ' Garden Grove ', location: 'California', date: '04.16.2024', },

    //   { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 31 },
    //   { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 31 },
    //   { id: 4, lastName: 'Stark', firstName: 'Arya', age: 11 },
    //   { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
    //   { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
    //   { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
    //   { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
    //   { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
];





function ManageLeads() {
    return (
        <Box>

            {/* <Typography sx={styles.pageTitle} variant="h5">Hello</Typography>
            <Box sx={styles.columnsContainer}>
            </Box> */}



            <div className="main-div">



                <div className="main-card">
                    <div className="wrapper-card-heading">

                        <h4 className="main-content-heading-col">Manage Leads</h4>
                        <Paper
                            component="form"
                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                        >
                            <SearchIcon />

                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder="Search by name/email"
                                inputProps={{ 'aria-label': 'search google maps' }}
                            />
                            <IconButton type="button" sx={{ p: '10px' }} aria-label="search">

                            </IconButton>
                            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />



                        </Paper>
                    </div>

                </div>



                <section className="admin-table-section">
                    <div className="main-card table-card-wrapper">
                        <div className="table-heading-row">
                            <div>
                                <h4> Recent 5 lead</h4>
                                <p>Sales Summery</p>
                            </div>

                            <div>
                                <Button variant="contained">VIEW ALL</Button>
                            </div>
                        </div>
                        <div>
                            <div className="manager-table">

                                <Box sx={{ height: '600', width: '100%' }}>
                                    <DataGrid
                                        rows={rows}
                                        columns={columns}
                                        initialState={{
                                            pagination: {
                                                paginationModel: {
                                                    pageSize: 9,
                                                },
                                            },
                                        }}
                                        pageSizeOptions={[9]}
                                        checkboxSelection
                                        disableRowSelectionOnClick
                                    />
                                </Box>
                            </div>

                            {/* <table>


          <thead>
            <tr>
              <td>S.No</td>
              <td>Patient Name</td>
              <td>Quiz Score</td>
              <td>Location</td>
              <td>Posted Date</td>
              <td>Status</td>
              <td>Action</td>
            </tr>

          </thead>


          <tbody>
            <tr>
              <th>1</th>
              <th>John Dawn</th>
              <th>15</th>
              <th>Texas</th>
              <th>04.10.2024</th>
              <th>Completed</th>
              <th><img src={eyeIcon}  alt="eye-icon"/> </th>
            </tr>

            <tr>
              <th>2</th>
              <th>Garden Grove</th>
              <th>14</th>
              <th>Alaska</th>
              <th>04.10.2024</th>
              <th>Completed</th>
              <th><img src={eyeIcon}  alt="eye-icon"/></th>
            </tr>


            <tr>
              <th>3</th>
              <th>Golden Oak </th>
              <th>12</th>
              <th>Arizona</th>
              <th>04.10.2024</th>
              <th>Completed</th>
              <th><img src={eyeIcon}  alt="eye-icon"/></th>
            </tr>


            <tr>
              <th>4</th>
              <th>Pine valley</th>
              <th>15</th>
              <th>Arkansas</th>
              <th>04.10.2024</th>
              <th>Completed</th>
              <th><img src={eyeIcon}  alt="eye-icon"/></th>
            </tr>


            <tr>
              <th>5</th>
              <th>Phoenix Center</th>
              <th>15</th>
              <th>California</th>
              <th>04.10.2024</th>
              <th>Completed</th>
              <th><img src={eyeIcon}  alt="eye-icon"/></th>
            </tr>


            <tr>
              <th>6</th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>


          </tbody>
         </table> */}
                        </div>
                    </div>
                </section>

            </div>

        </Box>
    );
}

// /** @type {import("@mui/material").SxProps} */
// const styles = {
//   pageTitle:{
//       mb:2
//   },
//   columnsContainer:{
//       colums:'500px 2'
//   }
// }
export default ManageLeads;




